import { components } from 'react-select';
import React from 'react';
import IconHandler from 'components/common/icon/IconHandler';
import { Box, Stack } from '@mui/material';

export const ReactSelectSingleValue = (props: any) => {
    const descRight = props.data.props?.desc_right;
    // A shorter text for the selected value than the option's label in the open list.
    const valueLabel = props.data.props?.value_label;
    return (
        <components.SingleValue {...props}>
            <Stack direction="row" justifyContent={'flex-start'} alignItems={'center'}>
                {props.data?.props?.displayIcon !== false && props.data.props?.icon && (
                    <Box
                        sx={{
                            mr: 1,
                            width: '16px',
                            height: '16px',
                            display: 'inline-flex',
                            alignItems: 'center',
                            '.svg-icon-mi': { fontSize: '16px' },
                            '.svg-inline--fa': { fontSize: '14px' },
                            img: {
                                maxWidth: '100%',
                                maxHeight: '100%',
                            },
                        }}
                    >
                        <IconHandler icon={props.data.props?.icon} color={props.data.props?.icon?.color} />
                    </Box>
                )}
                <Box sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {valueLabel ?? props.children}
                    {descRight && <> ({descRight})</>}
                </Box>
            </Stack>
        </components.SingleValue>
    );
};
